"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFullEstimateConfig = exports.defaultEstimateConfig = void 0;
var Destination_1 = require("./components/Destination");
var Disqualified_1 = require("./components/Disqualified");
var Quotes_1 = require("./components/Quotes");
var helper_1 = require("./helper");
exports.defaultEstimateConfig = {
    style: {
        color: {
            background: '#FFFFFF',
            textPrimary: '#110F10',
            textSecondary: '#6F6C65',
            border: '#D7D6D0',
            borderHover: '#6F6C65',
            borderFocused: '#110F10',
            buttonBackground: '#110F10',
            buttonBackgroundHover: '#6F6C65',
            buttonBackgroundDisabled: '#F2F2F2',
            buttonText: '#FFFFFF',
            buttonTextHover: '#FFFFFF',
            buttonTextDisabled: '#9D9D9D',
            quoteBackground: '#F2F2F2',
            errorText: '#822828',
            errorBackground: '#FBECEC',
        },
        position: 'right',
        pricingDisplay: 'starts_at',
        fontFamily: 'Neue Haas Grotesk Text Pro, Arial, Helvetica, sans-serif',
        fontSize: 14,
        width: 320,
        height: 467,
    },
    text: {
        detailOriginLabel: '(origin)',
        detailDestinationLabel: '(destination)',
        returnLinkLabel: 'Change Destination',
        header: {
            title: 'Estimate Shipping Costs',
        },
        destination: Destination_1.defaultDestinationConfig,
        quoted: Quotes_1.defaultQuoteConfig,
        disqualified: Disqualified_1.defaultDisqualifiedConfig,
    },
};
var getFullEstimateConfig = function (artaConfig, estimateConfig) {
    var finalConfig = (0, helper_1.nestedObjectAssign)((0, helper_1.deepClone)(exports.defaultEstimateConfig), artaConfig, (0, helper_1.deepClean)(estimateConfig));
    (0, helper_1.applySmallMobileStyling)(finalConfig);
    return finalConfig;
};
exports.getFullEstimateConfig = getFullEstimateConfig;
